import React from "react";
import { Flex } from "@ugc-ui/lego";
import { SkeletonBlock } from "@admin/pages/ShowCampaign/ShowCampaign.styled";
import { Spacer } from "@common/components/Statistic/ChartCustomTooltip.styled";

export const ViewTouchSkeletonPage = () => (
  <Flex flexDirection="column" gap={32} style={{ paddingTop: 20 }}>
    <SkeletonBlock height={25} width={320} />
    <Spacer />

    <Flex gap={8} flexDirection="column">
      <Flex flexDirection="row" justifyContent="space-between">
        <SkeletonBlock height={25} width={150} />
        <SkeletonBlock height={25} width={150} />
      </Flex>

      <Spacer />
    </Flex>

    <SkeletonBlock height={8} width={168} />

    <Flex flexDirection="row" justifyContent="space-between">
      <Flex flexDirection="column" gap={8}>
        <SkeletonBlock height={8} width={57} />
        <SkeletonBlock height={8} width={87} />
      </Flex>
      <Flex flexDirection="column" gap={8}>
        <SkeletonBlock height={8} width={57} />
        <SkeletonBlock height={8} width={87} />
      </Flex>
      <Flex flexDirection="column" gap={8}>
        <SkeletonBlock height={8} width={57} />
        <SkeletonBlock height={8} width={87} />
      </Flex>
    </Flex>

    <Spacer />

    <Flex flexDirection="row" justifyContent="space-between">
      <SkeletonBlock height={150} width={80} />
      <Flex flexDirection="column" gap={20}>
        <Flex flexDirection="column" gap={8}>
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={237} />
        </Flex>
        <Flex flexDirection="column" gap={8}>
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={237} />
        </Flex>
        <Flex flexDirection="column" gap={8}>
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={237} />
        </Flex>
      </Flex>
    </Flex>

    <Spacer />

    <Flex flexDirection="column" gap={8}>
      <SkeletonBlock height={8} width={57} />
      <SkeletonBlock height={8} width={350} />
    </Flex>

    <Flex flexDirection="column" gap={8}>
      <SkeletonBlock height={8} width={57} />
      <SkeletonBlock height={8} width={350} />
      <SkeletonBlock height={8} width={350} />
    </Flex>

    <Flex flexDirection="column" gap={8}>
      <SkeletonBlock height={8} width={57} />
      <SkeletonBlock height={8} width={350} />
    </Flex>

    <Flex flexDirection="column" gap={8}>
      <SkeletonBlock height={8} width={57} />
      <SkeletonBlock height={8} width={350} />
      <SkeletonBlock height={8} width={350} />
    </Flex>
  </Flex>
);
